import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { sortProductLines } from 'pricing-pages-lib/utils/sortingUtils';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { getAllFeaturesByAllProductLinesSelector } from '../../../selectors/FeatureSelectors';
import { Section } from '../../common/SharedComponents';
import { CommerceHubFeatureContent } from './CommerceHubFeatureContent';
import { Table, TableContainer } from './SuiteFeatureTableComponents';
import { SuiteFeatureTableContent } from './SuiteFeatureTableContent';
import SuiteFeatureTableHeader from './SuiteFeatureTableHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const initialSectionState = AllCombinedProductLines.reduce((agg, curr) => {
  agg[curr] = true;
  return agg;
}, {});
const initialFeatureTableState = AllCombinedProductLines.reduce((agg, curr) => {
  agg[curr] = false;
  return agg;
}, {});
const SuiteFeatureTable = ({
  productsByProductLine,
  screen,
  tab,
  isFreeToStarter,
  trackingSource,
  location
}) => {
  const [isSectionExpanded, setIsSectionExpanded] = useState(initialSectionState);
  const [isFeatureTableExpanded, setIsFeatureTableExpanded] = useState(initialFeatureTableState);
  const features = useSelector(getAllFeaturesByAllProductLinesSelector);
  const featureTableRef = useRef(null);
  const handleExpandSectionChange = productLine => {
    getUsageTracker().track('featureTableInteraction', {
      action: `clicked-${isSectionExpanded[productLine] ? 'collapse' : 'expand'}-section`,
      productLine,
      products: productsByProductLine[productLine],
      screen,
      tab,
      trackingSource
    });
    setIsSectionExpanded(prev => {
      return Object.assign({}, prev, {
        [productLine]: !prev[productLine]
      });
    });
  };
  const handleExpandFeatureTableChange = productLine => {
    getUsageTracker().track('featureTableInteraction', {
      action: `clicked-${isFeatureTableExpanded[productLine] ? 'collapse' : 'expand'}-table`,
      productLine,
      products: productsByProductLine[productLine],
      screen,
      tab,
      trackingSource
    });
    setIsFeatureTableExpanded(prev => {
      return Object.assign({}, prev, {
        [productLine]: !prev[productLine]
      });
    });
  };
  if (!Object.keys(features).length) return null;
  const sortedProductLines = sortProductLines(Object.keys(features));
  const levels = new Set();
  Object.values(productsByProductLine).forEach(products => {
    products.forEach(product => {
      const level = getProductLevelFromApiNameString(product);
      levels.add(level);
    });
  });
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_FEATURE_TABLE"
    }), /*#__PURE__*/_jsxs(TableContainer, {
      ref: featureTableRef,
      columns: levels.size,
      "data-selenium": "suite-feature-table",
      id: "feature-table",
      children: [/*#__PURE__*/_jsx(SuiteFeatureTableHeader, {
        levels: [...levels],
        isFreeToStarter: isFreeToStarter,
        location: location
      }), /*#__PURE__*/_jsxs(Table, {
        children: [sortedProductLines.map(productLine => /*#__PURE__*/_jsx(SuiteFeatureTableContent, {
          highlightedProducts: productsByProductLine[productLine],
          localFeatures: features[productLine],
          productLine: productLine,
          levels: levels,
          handleExpandSectionChange: handleExpandSectionChange,
          isSectionExpanded: isSectionExpanded,
          isFeatureTableExpanded: isFeatureTableExpanded,
          handleExpandFeatureTableChange: handleExpandFeatureTableChange
        }, productLine)), /*#__PURE__*/_jsx(CommerceHubFeatureContent, {
          levels: levels,
          handleExpandSectionChange: handleExpandSectionChange,
          isSectionExpanded: isSectionExpanded,
          handleExpandFeatureTableChange: handleExpandFeatureTableChange,
          isFeatureTableExpanded: isFeatureTableExpanded
        })]
      })]
    })]
  });
};
export default SuiteFeatureTable;